import { Box, getColor } from "@aircall/tractor";
import styled, { css } from "@xstyled/styled-components";

import { SentimentTooltipContentProps } from "./SentimentTooltip.decl";

function backgroundColor({ value }: SentimentTooltipContentProps) {
  switch (value) {
    case "POSITIVE":
      return getColor("surface-success");
    case "NEGATIVE":
      return getColor("surface-critical");
    default:
      break;
  }
}

function borderColor({ value }: SentimentTooltipContentProps) {
  switch (value) {
    case "POSITIVE":
      return getColor("success-700");
    case "NEGATIVE":
      return getColor("critical-700");
    default:
      break;
  }
}

function borderTopColorBefore({ value }: SentimentTooltipContentProps) {
  switch (value) {
    case "POSITIVE":
      return css`
        border-top-color: ${getColor("success-700")};
      `;
    case "NEGATIVE":
      return css`
        border-top-color: ${getColor("critical-700")};
      `;
    default:
      break;
  }
}

function borderTopColorAfter({ value }: SentimentTooltipContentProps) {
  switch (value) {
    case "POSITIVE":
      return css`
        border-top-color: ${getColor("surface-success")};
      `;
    case "NEGATIVE":
      return css`
        border-top-color: ${getColor("surface-critical")};
      `;
    default:
      break;
  }
}

export const BubbleContainer = styled(Box)<SentimentTooltipContentProps>`
  padding: 4px;
  height: fit-content;
  background-color: ${backgroundColor};
  border-width: 1px;
  border-style: solid;
  border-color: ${borderColor};
  border-radius: 24px;
  margin-bottom: 4px;
  position: relative;
  &::before,
  &::after {
    content: "";
    position: absolute;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    top: 100%;
    left: 50%;
    transform: translate(-50%);
  }

  &::before {
    border-top: 3px solid;

    ${borderTopColorBefore}
  }

  /* The background fill of the triangle */
  &::after {
    border-top: 3px solid;
    margin-top: -1.5px;
    z-index: 1;

    ${borderTopColorAfter}
  }
`;
